<template>
  <el-tabs v-model="activeTab">
    <el-tab-pane :label="$t('audit.old_version')" name="oldView">
      <p v-if="activeTab === 'oldView'"><OldMainView /></p>
    </el-tab-pane>
    <el-tab-pane :label="$t('audit.new_version')" name="newView">
      <p v-if="activeTab === 'newView'"><MainView /></p>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import OldMainView from "./OldMainView";
import MainView from "./MainView";

export default {
  components: {
    OldMainView,
    MainView
  },
  data() {
    return {
      activeTab: 'newView'
    };
  }
}
</script>



// WEBPACK FOOTER //
// src/components/audit/index.vue